import styled from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';

export const Error = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  p: {
    whiteSpace: 'pre-wrap',
    textAlign: 'left',
    marginBottom: 0,
  },

  strong: {
    borderBottom: 'dotted 1px #000',
  },

  svg: {
    marginRight: '10px',

    path: {
      fill: colors.lightTheme.base400,
    },
  },

  button: {
    cursor: 'pointer',
  },
});

export const ProductAlert = styled.div`
  margin-bottom: ${layout.measurements.spacing200};
`;

export const MainArea = styled.div`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
  width: 100%;
`;

export const CreateAlertWrapper = styled.div`
  max-width: 100%;
  display: grid;
  grid-row-gap: ${layout.measurements.spacing100};
  ${media.mediumUp`
    max-width: 60%;
  `}
`;
